var _g, _path, _rect, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5094_50325)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6094 35.6371L43.6094 29.0322M29.6094 35.6371L15.6094 29.0322M29.6094 35.6371V52.3613M43.6094 29.0322V43.8691L29.6094 52.3613M43.6094 29.0322L37.2338 26.2563M15.6094 29.0322V43.8691L29.6094 52.3613M15.6094 29.0322L21.7673 26.2563",
    stroke: "black",
    strokeWidth: 2.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5625 11.6844L29.5625 23.1563L29.5625 28.1294",
    stroke: "black",
    strokeWidth: 2.4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5094_50325",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 22,
    width: 24,
    height: 9
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.82031,
    height: 22.874,
    transform: "matrix(-1.19249e-08 1 1 1.19249e-08 18.5625 22.147)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5094_50325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5625 18.6528L29.5625 28.6528L39.5625 18.6528",
    stroke: "black",
    strokeWidth: 2.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5094_50325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.807129)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.0d5d8da3cf1934578c2e3ca5cd81cfa4.svg";
export { ForwardRef as ReactComponent };